import { useMarketplaceListedItems } from '../../hooks/MarketplaceLaunchedHook'
import CardGrid from '../design-system/CardGrid'
import CardLoader from '../design-system/CardLoader'
import ListedCard from '../shared/cards/ListedCard'
import EmptyState from '../shared/EmptyState'

export interface ListedItemsProps {
  account: string
  network: number
}

export default function ListedItems({ account, network }: ListedItemsProps) {
  const { nfts, loading, hasMore, loadMore } = useMarketplaceListedItems(account, network)

  if (!nfts.length && !loading) {
    return <EmptyState />
  }

  return (
    <CardGrid
      hasMore={hasMore}
      loader={<CardLoader />}
      loadMore={loadMore}
      data={nfts.map(item => (
        <ListedCard erc20={item} key={`${item.chainId}_${item.id}`} />
      ))}
    />
  )
}
